/**
 * Created by emanuele on 31/01/2017.
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

class ElaboraButton extends Component {
    render(){
        let classname = "ui left floated small primary labeled icon button";
        if (!this.props.enabled){
            classname += " disabled";
        }
        return <a href="#" onClick={(ev) => (this.props.onClick(ev))}>
            <div className={classname}>
                <i className={this.props.icon + " icon"}/>{this.props.text}
            </div>
        </a>
    }
}

ElaboraButton.PropTypes = {
    text: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    enabled: PropTypes.bool
};

ElaboraButton.defaultProps = {
    text: 'Elabora',
    icon: 'wizard',
    enabled: true
};

export default ElaboraButton;


/** WEBPACK FOOTER **
 ** ./src/components/ElaboraButton.jsx
 **/